{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/term-count",
	"title": "Term Count",
	"category": "theme",
	"description": "Displays the post count of a taxonomy term.",
	"textdomain": "default",
	"usesContext": [ "termId", "taxonomy" ],
	"attributes": {
		"bracketType": {
			"type": "string",
			"enum": [ "none", "round", "square", "curly", "angle" ],
			"default": "round"
		}
	},
	"supports": {
		"anchor": true,
		"html": false,
		"color": {
			"gradients": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true
			}
		},
		"spacing": {
			"padding": true
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"interactivity": {
			"clientNavigation": true
		},
		"__experimentalBorder": {
			"radius": true,
			"color": true,
			"width": true,
			"style": true,
			"__experimentalDefaultControls": {
				"color": true,
				"width": true,
				"style": true
			}
		}
	},
	"style": "wp-block-term-count"
}
